export class product_selection_filter {
    public excluded_connector_id: number;
    public selected_connector_id: number;
    public selected_company: string;
    public selected_finance_centre: string;
    public selected_product_group: string;
}